import { AxiosResponse } from "axios"
import { apiInstance } from "../base"
import {
    IRegisterOrganizationRequest,
    IRegisterOrganizationResponse,
    IProfileResponse,
    IUpdateContactRequest,
    IDashboardStatusResponse,
    IDashboardCardsResponse,
    IDashboardTransactionsRequest,
    IDashboardTransactionsResponse,
    ICreateBusinessCardRequest,
    ICreateBusinessCardResponse,
    IRequestPhoneConfirmationCodeRequest,
    IPhoneConfirmationResponse,
    IRequestEmailConfirmationCodeRequest,
    IEmailConfirmationResponse
} from "./types"

export const requestPhoneConfirmationCode = (data: IRequestPhoneConfirmationCodeRequest): Promise<AxiosResponse<IPhoneConfirmationResponse>> => {
    return apiInstance.handler.post<IPhoneConfirmationResponse>('/onboarding/registration/phone-confirmation', data)
}

export const requestEmailConfirmationCode = (data: IRequestEmailConfirmationCodeRequest): Promise<AxiosResponse<IEmailConfirmationResponse>> => {
    return apiInstance.handler.post<IEmailConfirmationResponse>('/onboarding/registration/email-confirmation', data)
}

export const registerOrganization = (data: IRegisterOrganizationRequest): Promise<AxiosResponse<IRegisterOrganizationResponse>> => {
    return apiInstance.handler.post<IRegisterOrganizationResponse>('/onboarding/registration', data)
}

export const getOrganizationProfile = (): Promise<AxiosResponse<IProfileResponse>> => {
    return apiInstance.handler.get<IProfileResponse>('/onboarding/profile')
}

export const updateContactPerson = (data: IUpdateContactRequest): Promise<AxiosResponse<IProfileResponse>> => {
    return apiInstance.handler.put<IProfileResponse>('/onboarding/profile/contact', data)
}

export const submitForModeration = (): Promise<AxiosResponse<IProfileResponse>> => {
    return apiInstance.handler.post<IProfileResponse>('/onboarding/profile/submit')
}

export const getDashboardStatus = (): Promise<AxiosResponse<IDashboardStatusResponse>> => {
    return apiInstance.handler.get<IDashboardStatusResponse>('/onboarding/dashboard/status')
}

export const getDashboardCards = (status?: string): Promise<AxiosResponse<IDashboardCardsResponse>> => {
    return apiInstance.handler.get<IDashboardCardsResponse>('/onboarding/dashboard/cards', {
        params: status ? { status } : undefined
    })
}

export const getDashboardTransactions = (params: IDashboardTransactionsRequest): Promise<AxiosResponse<IDashboardTransactionsResponse>> => {
    return apiInstance.handler.get<IDashboardTransactionsResponse>('/onboarding/dashboard/transactions', {
        params
    })
}

export const createBusinessCard = (data: ICreateBusinessCardRequest): Promise<AxiosResponse<ICreateBusinessCardResponse>> => {
    return apiInstance.handler.post<ICreateBusinessCardResponse>('/onboarding/dashboard/cards', data)
}

